import { Component, HostListener, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import {
  AlertInlineComponent,
  ToasterService,
  ModalComponent,
} from '@mars/ui-components';
import { ModalService } from './common/services/modal/modal.service';
import { AuthService } from './common/services/auth/auth.service';
import { UserState as UserStateType } from './common/models/user';
import { NavigationPipe } from './common/pipes/navigation/navigation.pipe';
import { Path } from './common/constants/paths.constant';
import { UserState } from './common/constants/userStates.constant';

@Component({
  imports: [RouterOutlet, AlertInlineComponent, ModalComponent],
  selector: 'mars-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'mars';

  protected readonly toastService = inject(ToasterService);
  protected readonly modalService = inject(ModalService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly navigationPipe = new NavigationPipe();

  @HostListener('window:beforeunload')
  onBeforeUnload() {
    sessionStorage.clear();
  }

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) this.checkAndUpdateUserState();
  }

  updateUserState(state: UserStateType) {
    const userData = this.authService.userData();
    const userType = this.authService.userType();
    if (
      !userData ||
      (userType?.user &&
        userData.user.state[userType.user] === state[userType.user])
    )
      return;

    const prevHasState =
      !!userData.user.state?.buyer ||
      !!userData.user.state?.supplier ||
      !!userData.user.state?.contractor;

    userData.user.state = state;
    this.authService.updateUser(userData);
    const currentHasState =
      !!userData.user.state.buyer ||
      !!userData.user.state.supplier ||
      !!userData.user.state.contractor;

    if (!prevHasState && currentHasState)
      this.router.navigate([
        '/' +
          this.navigationPipe.transform(`${userType?.user}/${Path.DASHBOARD}`),
      ]);

    this.handleNavigation();
  }

  checkAndUpdateUserState() {
    this.authService.getUserState().subscribe(response => {
      if (response?.user) {
        this.updateUserState(response.user.state);
      }
    });
  }

  handleNavigation() {
    const userType = this.authService.userType();
    if (!userType) return;
    const { user, state } = userType;

    if (user === 'supplier') {
      switch (state) {
        case UserState.APPROVE:
          this.router.navigate([
            '/' +
              this.navigationPipe.transform(
                `${Path.SUPPLIER}/${Path.DASHBOARD}`
              ),
          ]);
          break;
        case UserState.REJECTED:
          this.router.navigate([
            '/' + this.navigationPipe.transform(Path.SUPPLIER_REGISTRATION),
          ]);
          break;
      }
    } else if (user === 'contractor') {
      switch (state) {
        case UserState.APPROVE:
          this.router.navigate([
            '/' +
              this.navigationPipe.transform(
                `${Path.CONTRACTOR}/${Path.DASHBOARD}`
              ),
          ]);
          break;
        case UserState.REJECTED:
          this.router.navigate([
            '/' + this.navigationPipe.transform(Path.CONTRACTOR_REGISTRATION),
          ]);
          break;
        default:
          this.router.navigate([
            '/' +
              this.navigationPipe.transform(
                `${Path.CONTRACTOR}/${Path.DASHBOARD}`
              ),
          ]);
          break;
      }
    }
  }
}
